var map = {
	"./": 44237,
	"./assets/3rd-party-customization.svg": 30031,
	"./assets/about1-x.png": 16334,
	"./assets/about1.png": 74717,
	"./assets/about2-x.png": 68989,
	"./assets/about2.png": 33478,
	"./assets/authenticity.png": 22862,
	"./assets/aws.png": 36438,
	"./assets/brand1.svg": 88587,
	"./assets/brand2.svg": 49752,
	"./assets/brand3.svg": 84617,
	"./assets/brand4.svg": 82022,
	"./assets/brand5.svg": 69559,
	"./assets/cloud-and-devops-consulting.svg": 77525,
	"./assets/culture_1.png": 11795,
	"./assets/culture_2.png": 16184,
	"./assets/culture_3.png": 37313,
	"./assets/database-development-services.svg": 53105,
	"./assets/docker.png": 83701,
	"./assets/embedded-software.svg": 41710,
	"./assets/git.png": 32401,
	"./assets/hero_image-x.png": 13812,
	"./assets/hero_image.png": 23811,
	"./assets/innovation.png": 11580,
	"./assets/integrity.png": 55380,
	"./assets/it-support-services.svg": 89235,
	"./assets/mobile-application-development.svg": 12492,
	"./assets/mongodb.png": 26003,
	"./assets/mysql.png": 54479,
	"./assets/nestjs.png": 2974,
	"./assets/nodejs.png": 67920,
	"./assets/php.png": 13453,
	"./assets/postgresql.png": 84511,
	"./assets/quality-assurance.svg": 65818,
	"./assets/reactjs.png": 24753,
	"./assets/requirements-engineering.svg": 94305,
	"./assets/review_brand1.svg": 64634,
	"./assets/review_brand2.svg": 32745,
	"./assets/review_brand3.svg": 28504,
	"./assets/review_user1.svg": 69144,
	"./assets/review_user2.svg": 27211,
	"./assets/review_user3.svg": 33338,
	"./assets/service_ico1.svg": 43311,
	"./assets/service_ico2.svg": 40988,
	"./assets/service_ico3.svg": 69533,
	"./assets/service_ico4.svg": 35602,
	"./assets/solutions-architecture.svg": 89671,
	"./assets/startup-team-bootstrapping.svg": 21165,
	"./assets/ui-ux-designing.svg": 36124,
	"./assets/web-development.svg": 51539,
	"./index": 44237,
	"./index.jsx": 44237,
	"./style.scss": 34544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7559;